import { BO, BusinessObjectBase, NonUniqueModelDataError, RepositoryResponseConflictCodes, ResponseConflictObject, Weaver } from '@skylab-shared/core';
import { UnitModel } from '@skylab-shared/dataModel';
import { sameValues } from '@skylab-shared/utils';

@BO({ modelType: UnitModel })
export class UnitBO extends BusinessObjectBase<UnitModel> {
    private previousDefaultValue = false;

    public constructor(
        weaver: Weaver
    ) {
        super(weaver);
    }

    protected override async initializeAsync(): Promise<void> {
        await super.initializeAsync();
        this.configureReadonlyRules();

        if (this.model.isPersistent) {
            this.previousDefaultValue = this.model.default;
        }
    }

    protected override handleConflictSaveResponse(conflict: ResponseConflictObject<RepositoryResponseConflictCodes>) {
        if ((conflict.code === RepositoryResponseConflictCodes.UniqueConstraintViolation)) {
            const violations = [
                sameValues(conflict.objectProperties || [], ['name']) ? {
                    property: 'name',
                    violation: new NonUniqueModelDataError('business.unit.validation.name.server-rule-violations.non-unique-model-data-error')
                } : null,
                sameValues(conflict.objectProperties || [], ['symbol']) ? {
                    property: 'symbol',
                    violation: new NonUniqueModelDataError('business.unit.validation.symbol.server-rule-violations.non-unique-model-data-error')
                } : null
            ].filter((v): v is NonNullable<typeof v> => v !== null);

            this.addExternalRuleViolations({
                [this.model.sun]: violations
            });
        }
    }

    private configureReadonlyRules(): void {
        this.readonly.addRule([
            [UnitModel, 'default']
        ], () => this.previousDefaultValue);
    }
}
